import type { EventDataConstructor } from '@qodana/tracking/lib/types'

import type { CloudTrackingContext } from '../context'

export const withPage =
	<Arguments, EventTypes extends object>(
		eventDataConstructor: EventDataConstructor<Arguments, CloudTrackingContext, EventTypes>,
	) =>
	(args: Arguments, { page, ...rest }: CloudTrackingContext) => ({
		page,
		...eventDataConstructor(args, rest),
	})
